import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import InvisibleRecaptcha from '../invisible-recaptcha';
import moment from 'moment';

class Component extends BaseComponent {
    constructor() {
        super();

        this.recaptchaInstance;

        this.setState({
            name: null,
            email: null,
            month: null,
            day: null,
            year: null,
            password: null,
            verify_password: null,
            dh_wrs_optin: false,
            partner_optin: false,
            privacy_policy: false,
            formError: false,
            recaptchaCompleted: false,
            subscribe_lists: [],
        });
    }

    componentWillMount() {
        window.addEventListener('keydown', (e) => {
            if (e.keyCode == 27 && this.props.isOpen) {
                this.close();
            }
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.isOpen && !this.props.isOpen) {
            this.props.trackEvent(['Modal', 'show', 'Signup']);
        }

        if (!this.state.recaptchaCompleted && nextState.recaptchaCompleted) {
            this.userSignup();
        }

        return true;
    }

    render({ isOpen, user }) {
        if (isOpen) {
            return (
                <signup-modal-desktop class='open'>
                    <div class='backdrop' onClick={this.close} />
                    <form id='signup-form' onSubmit={this.submit}>
                        <header>
                            <a class='close' onClick={this.close}>×</a>
                            <h2>SO NICE TO SEE YOU!</h2>
                            <h1>Join Our Community</h1>
                        </header>
                        <main>
                            <h3>Quick and easy!</h3>
                            <div class='row'>
                                <div class='small-12 columns'>
                                    <p>Already a member? <a href='#login'>Login here.</a></p>
                                </div>
                            </div>
                            <div class='row'>
                                <div class='small-12 columns'>
                                    <div class={`input-container ${user.nameError ? 'error' : ''}`}>
                                        <input
                                          onFocus={() => this.props.trackEvent([
                                              'Modal',
                                              'Type-Name',
                                              'Signup',
                                          ])}
                                          onKeyup={this.setName}
                                          name='name'
                                          placeholder='What shall we call you?'
                                          type='text'
                                        />
                                    </div>
                                    {this.renderError(user.nameError)}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='small-12 columns'>
                                    <div class={`input-container ${user.emailError ? 'error' : ''}`}>
                                        <input
                                          onFocus={() => this.props.trackEvent([
                                              'Modal',
                                              'Type-Email',
                                              'Signup',
                                          ])}
                                          onKeyup={this.setEmail}
                                          name='email'
                                          placeholder='Your email address'
                                          type='email'
                                        />
                                    </div>
                                    {this.renderError(user.emailError)}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='small-3 columns'>
                                    <label>Birth date</label>
                                </div>
                                <div class='small-4 columns'>
                                    <div class={`select-container ${user.birthdateError ? 'error' : ''}`}>
                                        <select
                                          name='month'
                                          onFocus={() => this.props.trackEvent([
                                              'Modal',
                                              'Select-Month',
                                              'Signup',
                                          ])}
                                          onChange={this.setMonth}
                                        >
                                            <option disabled selected value=''>Month</option>
                                            <option value='01'>January</option>
                                            <option value='02'>February</option>
                                            <option value='03'>March</option>
                                            <option value='04'>April</option>
                                            <option value='05'>May</option>
                                            <option value='06'>June</option>
                                            <option value='07'>July</option>
                                            <option value='08'>August</option>
                                            <option value='09'>September</option>
                                            <option value='10'>October</option>
                                            <option value='11'>November</option>
                                            <option value='12'>December</option>
                                        </select>
                                    </div>
                                </div>
                                <div class='small-2 columns'>
                                    <div class={`select-container ${user.birthdateError ? 'error' : ''}`}>
                                        <select
                                          name='day'
                                          onFocus={() => this.props.trackEvent([
                                              'Modal',
                                              'Select-Day',
                                              'Signup',
                                          ])}
                                          onChange={this.setDay}
                                        >
                                            <option disabled selected value=''>Day</option>
                                            {this.renderDayOptions()}
                                        </select>
                                    </div>
                                </div>
                                <div class='small-3 columns'>
                                    <div class={`select-container ${user.birthdateError ? 'error' : ''}`}>
                                        <select
                                          name='year'
                                          onFocus={() => this.props.trackEvent([
                                              'Modal',
                                              'Select-Year',
                                              'Signup',
                                          ])}
                                          onChange={this.setYear}
                                        >
                                            <option disabled selected value=''>Year</option>
                                            {this.renderYearOptions()}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class='row'>
                                <div class='small-12 columns'>
                                    {this.renderError(user.birthdateError)}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='small-12 columns'>
                                    <div class={`input-container ${user.passwordError ? 'error' : ''}`}>
                                        <input
                                          onFocus={() => this.props.trackEvent([
                                              'Modal',
                                              'Type-Password',
                                              'Signup',
                                          ])}
                                          onKeyup={this.setPassword}
                                          name='password'
                                          placeholder='Password (case-sensitive)'
                                          type='password'
                                          maxLength='15'
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class='row'>
                                <div class='small-12 columns'>
                                    <div class={`input-container ${user.passwordError ? 'error' : ''}`}>
                                        <input
                                          onFocus={() => this.props.trackEvent([
                                              'Modal',
                                              'Type-Password-Verify',
                                              'Signup',
                                          ])}
                                          onKeyup={this.setVerifyPassword}
                                          name='password-verify'
                                          placeholder='Verify Password'
                                          type='password'
                                          maxLength='15'
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class='row'>
                                <div class='small-12 columns'>
                                    {this.renderError(user.passwordError)}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='small-12 columns'>
                                    <label class='checkbox'>
                                        <input
                                          name='dh_wrs_optin'
                                          onChange={this.setDHWRSOptin}
                                          checked={this.state.dh_wrs_optin}
                                          type='checkbox'
                                        />
                                        Get your Free Daily and Weekly Love Horoscope by email
                                    </label>
                                </div>
                            </div>
                            <div class='row'>
                                <div class='small-12 columns'>
                                    <label class='checkbox'>
                                        <input
                                          name='partner_optin'
                                          onChange={this.setPartnerOptin}
                                          checked={this.state.partner_optin}
                                          type='checkbox'
                                        />
                                        Get member discounts and exclusive offers from our partners
                                    </label>
                                </div>
                            </div>
                            {this.renderPPC()}
                        </main>
                        <footer>
                            <InvisibleRecaptcha
                              ref={e => this.recaptchaInstance = e}
                              onChange={this.handleChanged}
                              onExpired={this.handleExpired}
                            />
                            <button class='button-warning'>Enter</button>
                        </footer>
                    </form>
                </signup-modal-desktop>
            );
        }

        return (<signup-modal-desktop />);
    }

    renderPPC = () => {
        if (!this.props.ppc) {
            return (
                <div class='row'>
                    <div class='small-12 columns'>
                        <label class={`checkbox ${this.props.user.privacyPolicyError ? 'error' : ''}`}>
                            <input
                              name='privacy_policy'
                              onChange={this.setPrivacyPolicy}
                              type='checkbox'
                            />
                            I agree to Tarot.com's <a href='/privacy-policy' target='_blank'>Privacy
                            Policy</a> and <a href='/terms-of-use' target='_blank'>Terms of Use</a>.
                        </label>
                        {this.renderError(this.props.user.privacyPolicyError)}
                    </div>
                </div>
            );
        }

        return (
            <div class='row'>
                <div class='small-12 columns'>
                    <p class='legal-notice-link'>
                        By clicking "Enter" you accept our&nbsp;
                        <a
                          href='/privacy-policy'
                          data-name='goto_privacy_policy'
                          target='_blank'
                        >Privacy Policy</a>
                        &nbsp;and&nbsp;
                        <a
                          href='/terms-of-use'
                          data-name='goto_terms_of_use'
                          target='_blank'
                        >Terms of Use</a>.
                    </p>
                </div>
            </div>
        );
    }

    close = () => {
        this.props.trackEvent(['Modal', 'hide', 'Signup']);
        this.props.routeTo('');
    }

    submit = (e) => {
        e.preventDefault();

        this.setState({ formError: false });

        this.props.userUpdate({
            nameError: null,
            emailError: null,
            birthdateError: null,
            passwordError: null,
            privacyPolicyError: null,
        });

        this.validateName();
        this.validateEmail();
        this.validateBirthdate();
        this.validatePassword();

        if (!this.props.ppc) {
            this.validatePrivacyPolicy();
        }

        let subscribe_lists = ['ipe'];

        if (this.state.dh_wrs_optin) {
            subscribe_lists.push('dailyhoroscope');
            subscribe_lists.push('weekly_love');
        }

        if (this.state.partner_optin) {
            subscribe_lists.push('ope');
        }

        this.setState({ subscribe_lists: subscribe_lists });

        if (!this.state.formError) {
            this.recaptchaInstance._component.execute();
        }
    }

    renderError = (errorText) => {
        if (errorText) {
            return (<p class='error'>{errorText}</p>);
        }

        return null;
    }

    renderDayOptions = () => {
        if (this.state.month) {
            const year = this.state.year || moment().year();
            const days = moment(`${year}-${this.state.month}`, 'YYYY-MM').daysInMonth();

            return Array.from(Array(days).keys()).map(day => {
                return (
                    <option
                      value={(day + 1).toString().padStart(2, 0)}
                      selected={this.state.day == (day + 1)}
                    >
                        {day + 1}
                    </option>
                );
            });
        }

        return null;
    }

    renderYearOptions = () => {
        return Array.from(Array(101).keys()).map(d => {
            const year = moment().year() - d;

            if (year <= moment().year() - 13) {
                return (
                    <option
                      value={year}
                      selected={this.state.year == year}
                    >
                        {year}
                    </option>
                );
            }

            return null;
        });
    }

    setName = (e) => {
        this.setState({name: e.target.value});
    }

    setEmail = (e) => {
        this.setState({email: e.target.value});
    }

    setMonth = (e) => {
        this.setState({ month: e.target.value });
    }

    setDay = (e) => {
        this.setState({ day: e.target.value });
    }

    setYear = (e) => {
        this.setState({ year: e.target.value });
    }

    setPassword = (e) => {
        this.setState({password: e.target.value});
    }

    setVerifyPassword = (e) => {
        this.setState({verify_password: e.target.value});
    }

    setDHWRSOptin = (e) => {
        const action = e.target.checked ? 'Subscribe' : 'Unsubscribe';

        this.props.trackEvent([ 'Modal', `Select-${action}-Newsletter-Email`, 'Signup' ]);

        this.setState({ dh_wrs_optin: e.target.checked });
    }

    setPartnerOptin = (e) => {
        const action = e.target.checked ? 'Subscribe' : 'Unsubscribe';

        this.props.trackEvent([ 'Modal', `Select-${action}-Partner-Email`, 'Signup' ]);

        this.setState({ partner_optin: e.target.checked });
    }

    setPrivacyPolicy = (e) => {
        const action = e.target.checked ? 'Agree' : 'Disagree';

        this.props.trackEvent([ 'Modal', `Select-${action}-Privacy-Policy`, 'Signup' ]);

        this.setState({ privacy_policy: e.target.checked });
    }

    validateName = () => {
        if (!this.state.name) {
            this.setState({ formError: true });

            this.props.userUpdate({
                nameError: 'Please enter your name.',
            });
        }
    }

    validateEmail = () => {
        if (!this.state.email) {
            this.setState({ formError: true });

            this.props.userUpdate({
                emailError: 'Please enter your email address.',
            });
        } else {
            const atpos = this.state.email.indexOf('@');
            const dotpos = this.state.email.lastIndexOf('.');

            if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= this.state.email.length) {
                this.setState({ formError: true });

                this.props.userUpdate({
                    emailError: 'Please enter a valid email address.',
                });
            }
        }
    }

    validateBirthdate = () => {
        if (!this.state.month || !this.state.day || !this.state.year) {
            this.setState({ formError: true });

            this.props.userUpdate({
                birthdateError: 'Please enter your birth date.',
            });
        } else {
            const birthdate = moment(`${this.state.year}-${this.state.month}-${this.state.day}`);

            if (birthdate.isAfter(moment().subtract(13, 'years'))) {
                this.setState({ formError: true });

                this.props.userUpdate({
                    birthdateError: 'You must be at least 13 years of age to signup.',
                });
            }
        }
    }

    validatePassword = () => {
        if (!this.state.password || !this.state.verify_password) {
            this.setState({ formError: true });

            this.props.userUpdate({
                passwordError: 'Please enter a password.',
            });
        } else if (this.state.password != this.state.verify_password) {
            this.setState({ formError: true });

            this.props.userUpdate({
                passwordError: 'Your passwords don\'t match.',
            });
        } else if (this.state.password.length < 3 || this.state.password.length > 15) {
            this.setState({ formError: true });

            this.props.userUpdate({
                passwordError: 'Passwords must be between 3 and 15 characters long.',
            });
        }
    }

    validatePrivacyPolicy = () => {
        if (!this.state.privacy_policy) {
            this.setState({ formError: true });

            this.props.userUpdate({
                privacyPolicyError: 'Please agree before continuing.',
            });
        }
    }

    handleChanged = () => {
        this.setState({ recaptchaCompleted: true });
    }

    handleExpired = () => {
        this.setState({ recaptchaCompleted: false });
    }

    userSignup = () => {
        const birthdate = moment(`${this.state.year}-${this.state.month}-${this.state.day}`).format('YYYY-MM-DD');

        this.props.userSignup({
            first_name: this.state.name,
            display_name: this.state.name,
            email: this.state.email,
            password: this.state.password,
            password_verify: this.state.verify_password,
            signup_gateway: '#signup',
            signup_url: window.location.href,
            account_type_id: 1,
            signup_bonus: true,
            award_pfero: true,
            birth_date: birthdate,
            timezone: (new Date().getTimezoneOffset() / 60) * -1,
            welcome_email: true,
            subscribe_lists: this.state.subscribe_lists,
            privacy_policy: true,
        });
    }
}

const mapStateToProps = (state) => ({
    isOpen: state.route === 'signup',
    user: state.user,
    ppc: state.cookie && state.cookie.PRIVACY_POLICY_CONSENT,
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: route => dispatch({ type: 'route:to', payload: route }),
    userSignup: payload => dispatch({ type: 'user:signup-api', payload: payload }),
    trackEvent: payload => dispatch({ type: 'ga:event', payload: payload }),
    userUpdate: payload => dispatch({ type: 'user:update', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);


// WEBPACK FOOTER //
// ./app/components/user/signup-modal-desktop.js